import { render, staticRenderFns } from "./CartInfo.vue?vue&type=template&id=4003aafb&scoped=true"
import script from "./CartInfo.vue?vue&type=script&lang=js"
export * from "./CartInfo.vue?vue&type=script&lang=js"
import style0 from "./CartInfo.vue?vue&type=style&index=0&id=4003aafb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003aafb",
  null
  
)

export default component.exports